import * as React from "react";
import { useSelector, connect } from "react-redux";
import PdfView2 from "../components/PdfView2";
import { styles } from "../theme/styles";
import axios from "axios";
import { DatosCompradorContext } from "../context/Context";
function PdfViewer2(props) { 
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
  } = React.useContext(DatosCompradorContext);
  const [valorPdf, setValorPdf] = React.useState();
  const storedIdNumber = tiendaAsociadaContext;
  const IdNumber =
    useSelector((state) => state.users.idNumber) || storedIdNumber;

  function fixFolio(str) {
    return str.replace(/([A-Za-z])(\d+)/g, "$1_$2");
  }

  React.useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/getArchivo2Dir/NotaVenta${idbuscadoContext}.pdf`
      )
      .then((response) => {
        setValorPdf(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return <PdfView2 valorPdf={valorPdf} />;
}

export default PdfViewer2;
